import { render, staticRenderFns } from "./CheckoutFooter.vue?vue&type=template&id=2ddc0b86&scoped=true"
import script from "./CheckoutFooter.vue?vue&type=script&lang=ts"
export * from "./CheckoutFooter.vue?vue&type=script&lang=ts"
import style0 from "./CheckoutFooter.vue?vue&type=style&index=0&id=2ddc0b86&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ddc0b86",
  null
  
)

export default component.exports